var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-example-action-block",
      attrs: { id: "idModalExample" }
    },
    [
      _c("h4", { staticClass: "title" }, [_vm._v("Example Data")]),
      _vm._v(" "),
      _c("div", { staticClass: "copy", on: { click: _vm.copyJson } }, [
        _c("img", {
          staticClass: "m__r--2",
          attrs: { src: require("@/assets/icon/copy.svg"), width: "10" }
        }),
        _vm._v("\n    Copy\n  ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-data-json" },
        [
          _c("prism-editor", {
            staticClass: "my-editor",
            attrs: {
              highlight: _vm.highlighter,
              "line-numbers": true,
              readonly: true
            },
            model: {
              value: _vm.example_data,
              callback: function($$v) {
                _vm.example_data = $$v
              },
              expression: "example_data"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-row",
        [
          _c("b-col", { attrs: { md: "12" } }, [
            _c("div", { staticClass: "d-flex justify-content-end" }, [
              _c("div", { staticClass: "view-code" }, [
                _c("textarea", {
                  attrs: { id: "view-code" },
                  domProps: { value: _vm.example_data }
                })
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button-border m__t--10",
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("\n          Close\n        ")]
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-91dbf364", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91dbf364","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/popup/ModalExampleActionBlock.vue
// module id = null
// module chunks = 